import { bool, cleanEnv, str } from "envalid";

export function validateEnv() {
  return cleanEnv(import.meta.env, {
    LOG_LEVEL: str({ default: "info" }),
    VITE_ENABLE_TABLEAU: bool({
      default: true,
    }),
  });
}

export default validateEnv();
